import React from 'react';

import styles from './LayoutPageHeading.module.scss';
import { Row, Col } from 'antd';
import { GlobalSubline } from 'src/modules/global';
import { FormattedMessage } from 'react-intl';
import useRedrawOnMountKey from 'src/utils/useRedrawOnMountKey';
import { rowDefaultProps } from 'src/utils/grid';

interface PageHeadingProps {
  title?: string;
  subline?: string;
  titleKey?: string;
  sublineKey?: string;
  sublineJsx?: JSX.Element;
}

export const PageHeading: React.FunctionComponent<PageHeadingProps> = (props) => {
  const { title, titleKey, subline, sublineKey, sublineJsx } = props;

  const redrawKey = useRedrawOnMountKey();

  return (
    <Row {...rowDefaultProps} key={redrawKey}>
      <Col span={24}>
        <h2 className={styles.title}>
          {titleKey && <FormattedMessage id={titleKey} />}
          {!titleKey && title}
        </h2>
        <div>
          {(!!sublineKey || !!subline || !!sublineJsx) && (
            <GlobalSubline id={sublineKey} text={subline} jsx={sublineJsx} />
          )}
          {/* {sublineKey && (
            <FormattedMessage id={sublineKey}>
              {(txt: string) => <div dangerouslySetInnerHTML={{ __html: txt }}></div>}
            </FormattedMessage>
          )}

          {!sublineKey && <div dangerouslySetInnerHTML={{ __html: subline }} />} */}
        </div>
      </Col>
    </Row>
  );
};

export default PageHeading;
